<template>
    <div class="container">
        <h2 class="text-start offset-md-2 offset-1 mt-3 fw-bold">O NAS</h2>
        <div class="d-flex justify-content-center">
            <p class="m-3 w-custom-text">Avtoprevozništvo Jože Topler s.p. smo družinsko podjetje z {{year}}-letno tradicijo.
                Nudimo prevoze oseb in prtljage, razpolagamo s trinajstimi vozili.
                Za večje kose prtljage imamo na voljo prikolico. Poskrbimo za vse zahteve naših strank, odraža nas točnost, urejenost, organiziranost in cenovna ugodnost.
                Naši vozniki imajo veliko izkušenj z vožnjo doma in v tujini. Brezhibno izpeljemo potovanja po Sloveniji in celotni Evropi.
                Poskrbimo za zadovoljstvo naših strank in se priporočamo.</p>
        </div>
        <h2 class="text-start offset-md-2 offset-1 mt-3 fw-bold">VIZITKA PODJETJA</h2>
        <div class="mt-3"></div>
            <div class="d-flex justify-content-center">
                <table class="table-responsive text-start w-custom">
                    <tbody>
                        <tr class="customBorder">
                            <td>Dolg naziv PRS:</td>
                            <td>Avtoprevozništvo Jože Topler s.p.</td>
                        </tr>
                        <tr class="customBorder">
                            <td>Naslov:</td>
                            <td>Pohorska cesta 28a, 2367 Vuzenica</td>
                        </tr>
                        <tr class="customBorder">
                            <td>Matična številka:</td>
                            <td>5473329000</td>
                        </tr>
                        <tr class="customBorder">
                            <td>Davčna številka:</td>
                            <td>15928586</td>
                        </tr>
                        <tr>
                            <td>Bančni račun:</td>
                            <td>IBAN SI56 0486 0011 0621 609</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        <h2 class="text-start offset-md-2 offset-1 mt-3 mb-3 fw-bold">LOKACIJA</h2>
        <div class="row text-start mb-3">
            <div class="col-md-6">
                <div class="card m-2">
                    <h5 class="card-header">Sedež Podjetja</h5>
                    <div class="card-body">
                        <h5 class="card-title">Avtoprevozništvo Jože Topler s.p.</h5>
                        <p class="card-text">Pohorska cesta 28a <br> 2367 Vuzenica <br> Slovenija</p>
                        <iframe width="100%" src="https://maps.google.com/maps?q=Pohorska%20cesta%2028a,%202367%20Vuzenica,%20Slovenija&t=&z=15&ie=UTF8&iwloc=&output=embed"></iframe>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="card m-2">
                    <h5 class="card-header">PE Vuzenica</h5>
                    <div class="card-body">
                        <h5 class="card-title">Avtoprevozništvo Jože Topler s.p.</h5>
                        <p class="card-text">Sv. Primož na Pohorju 2 <br> 2367 Vuzenica <br> Slovenija</p>
                        <iframe width="100%" src="https://maps.google.com/maps?q=Sv.%20Primo%C5%BE%20na%20Pohorju%202,%202367%20Vuzenica,%20Slovenija&t=&z=15&ie=UTF8&iwloc=&output=embed"></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "About",
        data: () => ({
          year: ''
        }),
        methods: {
          printYear: function () {
            return new Date().getFullYear();
          }
        },
        mounted: function () {
          this.year = (this.printYear()-1995);
        },
    };
</script>